import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  loadingContainer: {
    width: '100%',
    height: '100%',
    minHeight: 150,
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  loadingText: {
    color: theme.palette.text.secondary,
  },
}));